import { CreatePhoneCallQueryParams } from "../models";
import { CreatePhoneCallFormSchema } from "../models/CreatePhoneCallForm.schema";

type AdditionalParams = {
  ladyId: number;
};

export const mapFormToQuery = (
  formData: CreatePhoneCallFormSchema,
  additionalParams: AdditionalParams,
): CreatePhoneCallQueryParams => {
  const ladyCallTime = `${formData.date
    .getDate()
    .toString()
    .padStart(2, "0")}.${(formData.date.getMonth() + 1)
    .toString()
    .padStart(
      2,
      "0",
    )}.${formData.date.getFullYear()} ${formData.time.getHours()}:${formData.time.getMinutes()}`;

  const timeZone = new Date().getTimezoneOffset().toString();

  return {
    ladyId: additionalParams.ladyId,
    callTime: formData.date,
    ladyCallTime: ladyCallTime,
    manCallTime: ladyCallTime,
    manPhone: formData.phone,
    timeZone,
  };
};
